import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import graphql from "utils/api/graphql";
import { GO_BACKS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const cancel = () => navigate(GO_BACKS.ONE);
  const [createAddress] = useMutation(graphql.mutations.CREATE_ADDRESS, {
    onCompleted: () => {
      navigate(GO_BACKS.ONE);
    },
    onError: () => {},
  });
  const onSubmit = (values) => {
    return createAddress({
      variables: {
        data: {
          ...values,
          token: { id: values.token },
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} />;
};

export default Create;
